export default "__VITE_ASSET__942e1bff__"